import { Component, h } from 'preact';

class Footer extends Component {
    constructor(props) {
        super(props);
    }

    render({className}, {}) {
        return(
            <footer>
                <div className={`download-software ${className}`}>
                    <div className='clearfix'>
                        <div className='col-sm-4 os33-logo'>
                            <h3>workplace<span>_</span></h3>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/scripts/views/tags/footer.js